import { z } from 'zod';

import { NonPerformanceCodeForReportingCycleId } from '../BrandedIds';
import { zodBrandedUuid, zodDateOrString } from '../utils';
import { NonPerformanceEvent } from './NonPerformanceEvent';

export const ReportingCycle = z.object({
  month: z.number(),
  year: z.number(),
});
export type ReportingCycle = z.infer<typeof ReportingCycle>;

export function cycleToKey(cycle: ReportingCycle): string {
  return `${cycle.year}-${cycle.month.toString().padStart(2, '0')}`;
}

export function previousCycle(cycle: ReportingCycle): ReportingCycle {
  const previousMonth = cycle.month === 1 ? 12 : cycle.month - 1;
  const previousYear = cycle.month === 1 ? cycle.year - 1 : cycle.year;
  return {
    year: previousYear,
    month: previousMonth,
  };
}

/**
 * This object has two purposes:
 *
 * - its presence (for a given cycle) indicates that the loan must be reported
 *   to investors in that cycle
 * - it normalizes the reportable non-performance events that occurred within
 *   a cycle into an array
 */
export const NonPerformanceCodeForReportingCycle = z.object({
  id: zodBrandedUuid<NonPerformanceCodeForReportingCycleId>(),

  cycle: ReportingCycle,

  events: NonPerformanceEvent.array().optional(), // LS TODO require after migration

  createdAt: zodDateOrString,
  updatedAt: zodDateOrString,
});

export type NonPerformanceCodeForReportingCycle = z.infer<typeof NonPerformanceCodeForReportingCycle>;
